module.exports = __webpack_public_path__ + "img/tj.7655ad61.svg";